import { Immutable } from "immer";

/**
 * Returns anchor attributes for links that may open in a new tab.
 * Includes the reverse-tabnabbing guard (`rel="noopener noreferrer"`)
 * whenever `target="_blank"` is set.
 */
export const newTabAttrs = (
    link: Immutable<{ open_in_new_tab: boolean }>,
): { target: "_blank"; rel: "noopener noreferrer" } | Record<string, never> =>
    link.open_in_new_tab
        ? ({ target: "_blank", rel: "noopener noreferrer" } as const)
        : ({} as const);
